<div class="team-leader-create">
  <div class="team-leader-create__content">
    <div class="team-leader-create__layout">
      <div class="team-leader-create__header">
        <div class="team-leader-create__heading">
          <h1 class="page-title">Create Team Leader</h1>
          <p class="page-subtitle">Add a new team leader with address details and assign partners.</p>
        </div>
        <div class="team-leader-create__actions">
          <app-button type="button" variant="secondary" (click)="goBack()">Back</app-button>
          <app-button type="button" [disabled]="isSaving || teamLeaderForm.invalid" (click)="saveTeamLeader()">
            {{ isSaving ? "Creating..." : "Create team leader" }}
          </app-button>
        </div>
      </div>

      <app-card>
        <form [formGroup]="teamLeaderForm" class="team-leader-create__form">
          <div class="team-leader-create__form-grid">
            <div class="team-leader-create__form-field">
              <div class="team-leader-create__form-label-row">
                <label for="name" class="team-leader-create__form-label">Name</label>
              </div>
              <input
                id="name"
                type="text"
                formControlName="name"
                autocomplete="off"
                class="team-leader-create__form-input"
                [class.team-leader-create__form-input--error]="teamLeaderForm.get('name')?.invalid && teamLeaderForm.get('name')?.touched" />
              @if (teamLeaderForm.get('name')?.invalid && teamLeaderForm.get('name')?.touched) {
              <div class="team-leader-create__form-error">Name is required and must be at least 2 characters</div>
              }
            </div>

            <div class="team-leader-create__form-field">
              <div class="team-leader-create__form-label-row">
                <label for="email" class="team-leader-create__form-label">Email</label>
              </div>
              <input id="email" type="email" formControlName="email" autocomplete="off" class="team-leader-create__form-input" />
            </div>
          </div>

          <div class="team-leader-create__form-grid">
            <div class="team-leader-create__form-field">
              <div class="team-leader-create__form-label-row">
                <label for="phone" class="team-leader-create__form-label">Phone</label>
              </div>
              <input id="phone" type="tel" formControlName="phone" autocomplete="off" class="team-leader-create__form-input" />
            </div>

            <div class="team-leader-create__form-field">
              <div class="team-leader-create__form-label-row">
                <label for="partners" class="team-leader-create__form-label">Partners</label>
              </div>
              <div class="team-leader-create__partner-autocomplete">
                <app-autocomplete
                  [prefetchOnInit]="false"
                  id="partners"
                  [options]="searchedPartners"
                  placeholder="Search partners..."
                  [minLength]="2"
                  [debounceMs]="300"
                  [multiSelect]="true"
                  [selectedValues]="selectedPartnerIds"
                  (searchChange)="searchPartners($event)"
                  (selectionChange)="onPartnerChange($event)" />
              </div>
            </div>
          </div>
        </form>
      </app-card>

      <app-card class="team-leader-create__address-card">
        <div class="team-leader-create__section-header">
          <div>
            <h2 class="team-leader-create__section-title">Address Information</h2>
            <p class="team-leader-create__section-hint">Select the location hierarchy and provide address details.</p>
          </div>
        </div>

        <app-location-selector (addressChange)="onAddressChange($event)"></app-location-selector>
      </app-card>
    </div>
  </div>
</div>
